const destinations = {
  pauseMode: "Pause Mode",
  flexPuff: "Flex Puff",
  flexBattery: "Flex Battery",
  softwareUpdate: "Software Update",
  lowPerformance: "Low Performance",
  personalizedCharging: "Personalized Charging",
  loyalty: "Loyalty",
  usage: "Usage",
  home: "Home",
  experienceCoach: "Experience Coach",
  loyaltyBadges: "Loyalty Badges",
  notifications: "Notifications"
};

export default destinations;
